import * as types from './actionTypes';
import * as AppConstants from '../constants/appConstants';
import * as localStorage from '../localStorage/localStorage';
import dataService from '../services/dataService';
import * as dataHelper from '../helpers/dataHelper';
import * as appHelper from '../helpers/appHelper';

export function setContentData(contentData) {
    return {type: types.SET_CONTENT_DATA, contentData};
}

export function initApp(initData) {
    return {type: types.INITIALISE, initData};
}

export function showContentOutlineDataInPreview(showContentOutlineInPreview){
    return {type: types.SET_SHOW_CONTENT_OUTLINE_IN_PREVIEW, showContentOutlineInPreview};
}

export function loadContentData(initData) {
    return function (dispatch) {
        let dataPath = require("../json/data.json");
        return dataService.loadData(dataPath).then(contentDataObj => {
            let contentData = Object.assign({},contentDataObj,{
                contentLoaded: true
            });
            //console.log(contentData);
            dispatch(setContentData(contentData));

            localStorage.setObject("contentData",contentData);
            if(appHelper.isDefined(contentData.experience.show_content_outline_in_preview)){
               dispatch(showContentOutlineDataInPreview(contentData.experience.show_content_outline_in_preview));
           }
        }).catch(error => {
            throw(error);
        });
    };
}

export function updateInitData(initData){
    return function (dispatch) {
        dispatch(initApp(initData));
    };
}


export function updateContentData(contentData){
    return function (dispatch) {
        dispatch(setContentData(contentData));
    };
}

export function checkPreloadedImageState(initData) {

}

export function showContentOutline(showContentOutlineInPreview){
    return function (dispatch) {
        dispatch(showContentOutlineDataInPreview(showContentOutlineInPreview));
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/initActions.js
 **/